import {
  permissionsRequestsTyped,
  type UpdateUserPermissionsBody,
} from "@/api/(requests)/permissionsTyped";
import type { UserPermissions, UUID } from "@/core/types";

export async function updateUserPermissions(
  userId: UUID,
  body: UpdateUserPermissionsBody,
): Promise<UserPermissions> {
  return permissionsRequestsTyped.update_user_permissions({
    body,
    urlParams: { userId },
  });
}
